import { Injectable } from '@angular/core';
import { CustomerAccount } from '@proximus/common-business-logic';
import { CustomerService, TranslationService } from '@proximus/ng-common';
import { Subscription } from 'rxjs';
import {
  MobileProduct,
  Pack,
  PlcCodes,
  Product,
} from '@dch/products-business-logic';

@Injectable({ providedIn: 'root' })
export class DetailsUtilService {
  private customerAccount: CustomerAccount;
  private customerAccountSubscription: Subscription;

  constructor(
    private readonly customerService: CustomerService,
    private readonly translationService: TranslationService,
  ) { }

  isKidsCardProduct(productMpcUuid: string): boolean {
    this.ensureCustomerAccountLoaded();

    const isUrCustomer = this.customerAccount?.isUr?.();
    const mpcUuidsRaw =
      this.translationService.getTranslatedValueFor('kidsCard.mpcUuids') || '';
    const mpcUuids = mpcUuidsRaw
      .split(',')
      .map((id) => id.trim())
      .filter((id) => !!id);

    return isUrCustomer && mpcUuids.includes(productMpcUuid);
  }

  filterMobileProducts(
    packs: Pack[],
    outOfPacks: Pack[],
    listOfMobilePlcs: PlcCodes[],
    endPhoneNumber?: string,
  ): MobileProduct[] {
    const mobileProducts: MobileProduct[] = [];

    for (const pack of [...packs, ...outOfPacks]) {
      const coreProducts = pack?.coreProducts || [];
      const matchingProducts = coreProducts.filter((product: Product): product is MobileProduct =>
        this.matchesMobileProduct(product, listOfMobilePlcs, endPhoneNumber),
      );

      mobileProducts.push(...matchingProducts);
    }

    return mobileProducts;
  }

  private ensureCustomerAccountLoaded(): void {
    if (this.customerAccountSubscription) {
      return;
    }

    this.customerAccountSubscription = this.customerService
      .getCustomerAccount()
      .subscribe((customerAccount) => {
        this.customerAccount = customerAccount;
      });
  }

  private matchesMobileProduct(
    product: Product,
    listOfMobilePlcs: PlcCodes[],
    endPhoneNumber?: string,
  ): product is MobileProduct {
    return (
      !!product &&
      listOfMobilePlcs.includes(product.plc) &&
      (!endPhoneNumber || product.accessNumber?.endsWith(endPhoneNumber))
    );
  }
}
